export default "__VITE_ASSET__Biv6TqEu__"